import { Yup } from "lib/extendYup";

export const userInfoValidationSchema = Yup.object().shape({
  firstName: Yup.string().required("First name is required"),
  lastName: Yup.string().required("Last name is required"),
  email: Yup.string().required("Email is required"),
  roleId: Yup.string().required("Select user's role"),
});
